<div (window:resize)="onResize()">
  @if (url) {
    <iframe [src]="sanitizer.bypassSecurityTrustResourceUrl(url)"
            width="100%" [height]="height" frameborder="0"></iframe>
  }
</div>
